import React from 'react';
import { FadeUp } from './FadeUp';
import { CircuitPattern } from './illustrations/CircuitPattern';
export function Problem() {
  const painPoints = [{
    icon: '📭',
    title: 'You post consistently — nothing happens',
    desc: 'Hours of work, zero traction. The algorithm keeps ignoring you.'
  }, {
    icon: '👻',
    title: 'Your profile looks empty',
    desc: "No activity makes your brand feel abandoned — even when it isn't."
  }, {
    icon: '🔎',
    title: "People visit but don't trust you",
    desc: 'They scroll through, hesitate, and leave. No trust means no sale.'
  }, {
    icon: '📉',
    title: 'Your reach keeps dropping',
    desc: 'You post more, reach less. Organic reach is dying without the right signals.'
  }];
  return <section id="problema" className="relative z-10 py-[72px] md:py-[100px] overflow-hidden" data-id="element-209">
      {/* Background Circuit Pattern */}
      <div className="absolute top-0 right-[-10%] w-[500px] h-[120%] pointer-events-none -z-10" data-id="element-210">
        <CircuitPattern data-id="element-211" />
      </div>

      <div className="max-w-[900px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-212">
        <FadeUp data-id="element-213">
          <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-214">
            Sound familiar?
          </span>
          <h2 className="font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6" data-id="element-215">
            <span className="text-[clamp(26px,4vw,36px)]" data-id="element-216">
              Your content is good.
            </span>
            <br data-id="element-217" />
            <span className="text-[clamp(18px,2.8vw,24px)] text-white-dim" data-id="element-218">
              But nobody's seeing it.
            </span>
          </h2>
          <p className="text-white-dim text-base max-w-[560px] leading-[1.7]" data-id="element-219">
            It's not a lack of talent or effort. It's a perception problem.
            Instagram decides who to show your content to based on signals that
            most accounts simply don't have.
          </p>
        </FadeUp>

        <ul className="flex flex-col gap-3.5 list-none" data-id="element-220">
          {painPoints.map((point, i) => <FadeUp key={i} as="li" delay={i * 0.08} data-id="element-221">
              <div className="flex items-start gap-3.5 bg-bg-card border border-cyan/10 rounded-sm p-[18px_20px] transition-all duration-250 ease-in hover:border-cyan/40 card-glow-hover" data-id="element-222">
                <span className="text-[20px] shrink-0 mt-0.5" data-id="element-223">
                  {point.icon}
                </span>
                <div className="text-[14px] font-heading font-semibold uppercase tracking-[0.05em] leading-[1.5]" data-id="element-224">
                  {point.title}
                  <span className="block text-[13px] font-sans normal-case tracking-normal text-white-dim font-normal mt-1.5" data-id="element-225">
                    {point.desc}
                  </span>
                </div>
              </div>
            </FadeUp>)}
        </ul>
      </div>
    </section>;
}